module.exports = __webpack_public_path__ + "public/images/upserve_loader_icon.png";